import apiClient from '@/shared/api/client';
import type { ApiResponse } from '@/shared/api/types';
import type { CommunicationPreference, CommunicationPreferencePatch } from '@/modules/agents/utils/commsLabels';

/** The practice's door onto CommunicationPreference: only the agents switched on for it. */
export const practiceCommsApi = {
  list: async (): Promise<CommunicationPreference[]> => {
    const { data } = await apiClient.get<ApiResponse<CommunicationPreference[]>>('/practice/comms');
    return data.data;
  },

  update: async (agentType: string, patch: CommunicationPreferencePatch): Promise<CommunicationPreference> => {
    const { data } = await apiClient.put<ApiResponse<CommunicationPreference>>(
      `/practice/comms/${encodeURIComponent(agentType)}`,
      patch,
    );
    return data.data;
  },
};
